import {ISelectItem} from '../../../../shared/types';

export const statusOptions: ISelectItem[] = [
  {
    id: '1',
    name: 'Saved Search',
    label: 'Saved Search',
  },
  {
    id: '2',
    name: 'Tags',
    label: 'Tags',
  },
  {
    id: '3',
    name: 'Folders',
    label: 'Folders',
  },
];

export interface ITreeNode {
  id: string;
  label: string;
  count: string;
  isCascadeEnabled: boolean;
  showMoreOptions: boolean;
  parent: string | null;
  text: string;
  documentCount: number;
  li_attr: {isCascadeEnabled: boolean};
  children: ITreeNode[];
}

export const getTreeDataForType = (type: any, treeData: any) => {
  switch (type) {
    case 'Tags':
      return treeData

    case 'Folders':
      return treeData

    case 'Saved Search':
      return treeData

    default:
      return [];
  }
};
